import HeartOne from './HeartOne'

export default HeartOne
